import React from "react";
import { detectDeviceType } from "../../../utils/detectDeviceType";
import { UserTranscriptTypes } from "../../../types/ContentCard";
import { UserMessage } from "./UserTranscriptStyles";

const UserTranscript: React.FC<{
  contentCardData: UserTranscriptTypes;
  tabletLandscape: boolean;
}> = ({ contentCardData, tabletLandscape }) => {
  return (
    <UserMessage>
      <div className="talk-bubble tri-right btm-right">
        <div className="talktext">
          <p>{contentCardData.data.transcript}</p>
        </div>
      </div>
    </UserMessage>
  );
};

export default UserTranscript;
